import PrimaryLogo from "./PrimaryLogo";

export default PrimaryLogo;
